import { render } from "./ImplantForm.vue?vue&type=template&id=693f1cde&scoped=true"
import script from "./ImplantForm.vue?vue&type=script&lang=js"
export * from "./ImplantForm.vue?vue&type=script&lang=js"

import "./ImplantForm.vue?vue&type=style&index=0&id=693f1cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693f1cde"]])

export default __exports__